/* A component that edits the form base details. */
import React, { Component } from "react"
import { Button, FormControl, Modal } from "react-bootstrap"
import Select from "react-select"
import stateMutator from "../../Utils/StateMutator"
import DynamicFormTypes from "../../Types/DynamicFormsTypes"
import "./DynamicFormEditBaseDetails.css"

interface Props {
    form: DynamicFormTypes
    formTypes: Array<{ CustomFormTypeId: number, Type: string }>
    manageParentState: Function
}

interface State {
    form: DynamicFormTypes
    input: string
    eventType: string
}

class DynamicFormEditBaseDetails extends Component<Props, State> {

    state = {
        form: this.props.form,
        input: "",
        eventType: "",
    }

    /* A function that is used to update the state. It is used to prevent the state from being updated in
    an uncontrolled manner. */
    manageState = (keys: Array<{ key: string, value?: any }>) => {
        this.setState(stateMutator.mutate(this.state, keys))
    }

    handleChange = (event: { target: { value: any } }) => {
        const input = event.target.value
        let temp = this.props.form
        //@ts-ignore
        temp[this.state.eventType] = input.length > 0 ? input : null
        this.manageState([{ key: "form", value: temp }])
        this.props.manageParentState([{ key: "form", value: temp }])
    }

    /* A function that is used to get the form type reference data by id. */
    getFormTypeRefDataById = (id: number) => {
        const refData = this.props.formTypes.filter(obj => {
            return obj.CustomFormTypeId === id
        })[0]
        return refData || { Type: "Choose type" }
    }

    render() {

        const state = this.state
        const props = this.props

        return (
            <div className="DynamicFormEditBaseDetails">
                <Modal
                    id="edit-dyanimic-form-base-details-modal"
                    show={true}
                    backdrop="static"
                    keyboard={true}
                    centered={true}
                >
                    <Modal.Body>
                        <div className="DynamicFormEditBaseDetailsModalBody">
                            <div className="DynamicFormEditBaseDetailsModalBodyItem">
                                <div className="DynamicFormEditBaseDetailsModalBodyItemHeader">
                                    <p>Name</p>
                                </div>
                                <FormControl onFocus={() => this.manageState([{ key: "eventType", value: "Name" }])}
                                    onChange={this.handleChange}
                                    value={state.form.Name || ""}
                                    type="text"
                                />
                            </div>
                            <div className="DynamicFormEditBaseDetailsModalBodyItem">
                                <div className="DynamicFormEditBaseDetailsModalBodyItemHeader">
                                    <p>Type</p>
                                </div>
                                <Select
                                    placeholder={"Form Type"}
                                    //@ts-ignore
                                    value={{ label: this.getFormTypeRefDataById(props.form.CustomFormTypeId).Type }}
                                    options={props.formTypes.map((item) => ({ value: item.CustomFormTypeId, label: item.Type }))}
                                    onChange={(item: { value: string, label: string }) => {
                                        let temp = props.form
                                        //@ts-ignore
                                        temp.CustomFormTypeId = item.value
                                        props.manageParentState([{ key: "form", value: temp }])
                                    }}
                                />
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="DynamicFormEditBaseDetailsModalFooter">
                            <div className="DynamicFormEditBaseDetailsModalFooterNotBusy">
                                <Button disabled={!state.form.Name} variant="primary" onClick={() => this.props.manageParentState([{ key: "editBaseDetails", value: null }])}>Ok</Button>
                            </div>
                        </div>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}

export default DynamicFormEditBaseDetails